import { render, staticRenderFns } from "./AIButton.vue?vue&type=template&id=3e3f5536&scoped=true"
import script from "./AIButton.vue?vue&type=script&lang=js"
export * from "./AIButton.vue?vue&type=script&lang=js"
import style0 from "./AIButton.vue?vue&type=style&index=0&id=3e3f5536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3f5536",
  null
  
)

export default component.exports